import styled from 'styled-components';
import DatePicker from 'react-date-picker';
import TimePicker from 'react-time-picker';

export const RoundedWrapper = styled.div.attrs({
  className: 'col-12 mt-3'
})`
  border: 1px solid #E0E0E0;
  border-radius: 6px;
  max-height: calc(100vh - 100px);
`

export const IframeWrapper = styled.div.attrs({
  className: 'mb-3'
})`
  max-height: calc(100vh - 300px);
  scroll-behavior: smooth;

  @media (max-width: 768px) {
    max-height: calc(100vh - 384px);
  }
`

export const EmptyWrapper = styled.div.attrs({
  className: 'mb-3'
})`
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  height: calc(100vh - 400px);
  background-color: ${({theme}) => theme.getRGBA(theme.mocaGrey, 0.1)};

  @media (max-width: 768px) {
    height: calc(100vh - 484px);
  }
`

export const PageWrapper = styled.div.attrs(({ isMobile }) => ({
  className: 'p-4'
}))``

export const FilterRow = styled.div.attrs({
  className: 'col-12 mt-3 pb-3 px-0'
})`
  display: flex;
  flex-direction: row;
  align-items: flex-end;

  @media (max-width: 1424px) {
    flex-wrap: wrap;
    padding-top: 0 !important;
  }
`

export const FilterCol = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-right: 20px;

  @media (max-width: 1024px) {
    margin-right: 5px;
  }

  @media (max-width: 768px) {
    margin-right: 10px;
    margin-top: 10px;
  }
`

export const TimeWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
`
export const TimeSeparatorLabel = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
`

export const StyledDatePicker = styled(DatePicker)`
  .react-date-picker__wrapper {
    border-radius: 6px !important;
    font-size: 14px !important;
    height: 34px !important;
    border: 1px solid ${({ theme }) => theme.mocaGrey};
  }
`

export const StyledTimePicker = styled(TimePicker)`
  .react-time-picker__wrapper {
    border-radius: 6px !important;
    font-size: 14px !important;
    height: 34px !important;
    border: 1px solid ${({ theme }) => theme.mocaGrey};
  }
`

export const TableWrapper = styled.div.attrs({
  className: 'col-12 mt-3 px-0'
})`
  border: 1px solid #E0E0E0;
  border-radius: 6px;
  overflow-x: auto;
`